import classNames from 'classnames';
import React from 'react';

import { currencyFormatter } from '../../shared/numberFormat';

import './CurrencyExchangeDescription.scss';

interface Props {
    label: string;
    value?: number;
    className?: string;
}

const CurrencyExchangeDescription: React.FC<Props> = ({ label, value = 0, className }) => {
    return (
        <div className={classNames('currency-exchange-description', className)}>
            <dt className="currency-exchange-description__label">{label}</dt>
            <dd className="currency-exchange-description__value" data-testid="payment-amount-nok">
                {currencyFormatter(value, 'NOK')}
            </dd>
        </div>
    );
};

export default CurrencyExchangeDescription;
